[
  {
    "key": "label",
    "name": "label",
    "kind": "Text",
    "label": "Field Name",
    "require_expression": true,
    "description": "Label displayed with the value of the field.",
    "mutable": true
  },
  {
    "key": "description",
    "name": "description",
    "kind": "Text",
    "label": "Description",
    "description": "Description of the field that is displayed in a tooltip when someone clicks on the field's label.",
    "mutable": true
  },
  {
    "key": "dateFormat",
    "name": "dateFormat",
    "kind": "Lookup",
    "label": "Format",
    "show_expression": "{kind} = \"Date\"",
    "description": "Format in which the value of the field is displayed.",
    "mutable": true
  },
  {
    "key": "numberFormat",
    "name": "numberFormat",
    "kind": "Lookup",
    "label": "Format",
    "lookup_values": [
      { "value": "Decimal", "label": "1 Decimal" },
      { "value": "Decimals", "label": "2 Decimals" },
      { "value": "Abbreviated", "label": "Abbreviated" },
      { "value": "BigNumber", "label": "Big Number" },
      { "value": "Percent", "label": "Percent" },
      { "value": "WholeNumber", "label": "Whole Number" }
    ],
    "show_expression": "{kind} = \"Distance\" OR {kind} = \"Number\" OR {kind} = \"Area\" OR {kind} = \"Length\"",
    "description": "Format in which the value of the field is displayed.",
    "mutable": true
  },
  {
    "key": "numericalFormat",
    "name": "numericalFormat",
    "kind": "Lookup",
    "label": "Format",
    "lookup_values": [
      { "value": "Abbreviated", "label": "Abbreviated" },
      { "value": "WithFractions", "label": "With Fractions" },
      { "value": "WithoutFractions", "label": "Without Fractions" }
    ],
    "show_expression": "{kind} = \"Money\"",
    "description": "Format in which the value of the field is displayed.",
    "mutable": true
  },
  {
    "key": "isCalculated",
    "name": "isCalculated",
    "kind": "Boolean",
    "label": "Calculated Field?",
    "description": "Flag indicating whether the field's value is calculated rather than inputted. If yes, an expression must be provided.",
    "mutable": true,
    "show_expression": "{kind} <> \"Contact\" AND {kind} <> \"InternalContact\""
  },
  {
    "key": "expression",
    "name": "expression",
    "kind": "Text",
    "label": "Formula",
    "show_expression": "{isCalculated}",
    "require_expression": "{isCalculated}",
    "description": "Expression used to calculate the field's value.",
    "mutable": true
  },
  {
    "key": "default_expression",
    "name": "default_expression",
    "kind": "Text",
    "label": "Default Value/Formula",
    "show_expression": "not({isCalculated}) AND {kind} <> \"RichText\" AND {kind} <> \"Contact\" AND {kind} <> \"InternalContact\"",
    "description": "Expression used to calculate the field's value when no value is inputted.",
    "mutable": true
  },
  {
    "key": "prioritize_default_expression",
    "name": "prioritize_default_expression",
    "kind": "Boolean",
    "label": "Prioritize?",
    "show_expression": "not({isCalculated}) AND {kind} <> \"RichText\" AND {kind} <> \"Contact\" AND {kind} <> \"InternalContact\"",
    "description": "Flag indicating whether the default value/formula should override a manually entered value.",
    "mutable": true
  },
  {
    "key": "basis_kind",
    "name": "basis_kind",
    "kind": "Lookup",
    "label": "Basis Type",
    "lookup_values": [
      { "value": "area", "label": "Area" },
      { "value": "length", "label": "Length" },
      { "value": "distance", "label": "Distance" }
    ],
    "description": "For a rate calculation, the type of field used as the rate basis.",
    "show_expression": "{kind} = \"Money\"",
    "mutable": true
  },
  {
    "key": "display_unit_code",
    "name": "display_unit_code",
    "kind": "Lookup",
    "label": "Display Unit",
    "lookup_values": [
      {
        "value": "ACRE",
        "label": "Acres"
      },
      {
        "value": "SF",
        "label": "Square Feet"
      },
      {
        "value": "SM",
        "label": "Square Meters"
      }
    ],
    "description": "Unit in which values will be displayed.",
    "show_expression": "{kind} = \"Area\" AND {convert_for_display}",
    "mutable": true
  },
  {
    "key": "isConditionallyShown",
    "name": "isConditionallyShown",
    "kind": "Boolean",
    "label": "Conditionally Shown?",
    "description": "Flag indicating whether the field is only shown based on the value of other fields. If yes, an expression must be provided.",
    "mutable": true
  },
  {
    "key": "show_expression",
    "name": "show_expression",
    "kind": "Text",
    "label": "Show If (Formula)",
    "show_expression": "{isConditionallyShown}",
    "require_expression": "{isConditionallyShown}",
    "description": "Expression used to determine whether the field is shown.",
    "mutable": true
  },
  {
    "key": "convert_for_display",
    "name": "convert_for_display",
    "kind": "Boolean",
    "label": "Convert Value for Display?",
    "show_expression": "{kind} = \"Distance\" OR {kind} = \"Money\" OR {kind} = \"Area\" OR {kind} = \"Length\"",
    "description": "Flag indicating if the field's value should be converted to the default unit for display.",
    "mutable": true
  },
  {
    "key": "multiple_values",
    "name": "multiple_values",
    "kind": "Boolean",
    "label": "Allow Multiple Values?",
    "show_expression": "{kind} = \"Text\" OR {kind} = \"Lookup\" OR {kind} = \"Contact\" OR {kind} = \"InternalContact\" OR {kind} = \"Company\" OR {kind} = \"Portfolio\" OR {kind} = \"User\"",
    "description": "Flag indicating if the field can accept multiple values."
  },
  {
    "key": "summary_method",
    "name": "kind",
    "kind": "Lookup",
    "label": "Summary Method",
    "lookup_values": [
      { "value": "sum", "label": "Sum" },
      { "value": "weighted_sum", "label": "Weighted Sum" },
      { "value": "average", "label": "Average" },
      { "value": "weighted_average", "label": "Weighted Average" }
    ],
    "show_expression": "{kind} = \"Distance\" OR {kind} = \"Number\" OR {kind} = \"Money\" OR {kind} = \"Area\" OR {kind} = \"Length\"",
    "description": "Method used to summarize values in the field.",
    "mutable": true
  },
  {
    "key": "weight_field_id",
    "name": "weight_field_id",
    "kind": "Lookup",
    "label": "Weight Field",
    "require_expression": true,
    "show_expression": "{summary_method} = \"weighted_average\" OR {summary_method} = \"weighted_sum\"",
    "description": "Field used to weight values when Summary Method is a \"Weighted\" method",
    "mutable": true
  }
]
